module.exports = __webpack_public_path__ + "static/cw-white-13bb529248b65b5e4a4d141ada8b9d39.png";